import React from 'react';
import BuyListingNowApplePayButton from './buy_listing_now_apple_pay_button';
import { MParticleEventName } from '@reverbdotcom/commons/src/elog/mparticle_types';
import { useViewTracking } from '@reverbdotcom/commons/src/use_tracking';
import { CheckoutItemPageReturnError } from './checkout_item_page_return_layout';
import { useApplePayAvailabilityByConfig } from './useApplePayAvailability';
import { core_apimessages_Error as Error } from '@reverbdotcom/commons/src/gql/graphql';

interface Props {
  listingId: string;
  listingCurrencyCode: string;
  paymentMethodsConfig: string;
  quantity: number;
  onError: (error: Error) => void;
  small?: boolean;
}

export default function BuyItNowApplePayWrapper({
  listingCurrencyCode,
  paymentMethodsConfig,
  listingId,
  onError,
  quantity,
  small = false,
}: Props) {
  const [isAvailable, loading] = useApplePayAvailabilityByConfig(paymentMethodsConfig);

  function onAppleError(errorType: CheckoutItemPageReturnError, message: string) {
    if (['PAYMENT_FAILURE', 'CHECKOUT_FAILURE'].includes(errorType)) {
      onError({ message });
    }
  }

  useViewTracking({
    componentName: 'BuyListingNowApplePayButton',
    eventName: MParticleEventName.ApplePayOffered,
    applePayAvailableForDevice: isAvailable,
  }, !loading);

  if (!isAvailable) {
    return null;
  }

  return (
    <BuyListingNowApplePayButton
      data-buy-listing-now-apple-pay-button
      listingId={listingId}
      paymentMethodsConfig={paymentMethodsConfig}
      listingCurrencyCode={listingCurrencyCode}
      onError={onAppleError}
      quantity={quantity}
      small={small}
    />
  );
}
